import imageCompression from "browser-image-compression";

export async function mediaSourceToFile(source: string, filename: string) {
    const response = await fetch(source);
    if (!response.ok) {
        throw new Error(`Failed to read image source: ${response.status}`);
    }

    const blob = await response.blob();
    const type = blob.type || "image/webp";
    return new File([blob], filename, {type});
}

export async function prepareImageFile(
    source: string,
    filename: string,
    options: {
        maxSizeMB: number;
        maxWidthOrHeight: number;
    }
) {
    const originalFile = await mediaSourceToFile(source, filename);
    return imageCompression(originalFile, {
        fileType: "image/webp",
        initialQuality: 0.5,
        useWebWorker: true,
        ...options
    });
}

export function makeFileName(prefix: string, fallbackName: string) {
    const base = fallbackName.replace(/\.[^.]+$/, "").replace(/[^a-zA-Z0-9_-]/g, "_") || prefix;
    return `${base}_${Date.now()}.webp`;
}
